import axios from 'axios'
import HTTP from './http'

export default {
    servicesList: () => axios.get(HTTP.SERVICES_LIST),
    handleFreezeServie: (id, active) => axios.post(HTTP.FREEZE_SERVICE, { id, active }),
    updateService: item => axios.post(HTTP.SERVICES_LIST, { item }),
    addNewService: payload => axios.post(HTTP.ADD_SERVICE, { payload }),
    updateServicePrice: payload => axios.post(HTTP.UPDATE_SERVICE_PRICE, { payload }),
    // getGeneralOptions: () => axios.get(HTTP.GENERAL_OPTIONS),
    createGeneralRequest: payload => axios.post(HTTP.SERVICES_GENERAL, { params: payload }),
    getServiceDashboardData: (payload?) => axios.get(HTTP.SERVICE_DASHBOARD , { params: { ...payload } }),
    getGeneralOptions: id => axios.get(HTTP.GENERAL_OPTIONS, { params: { id } }),
    addFlyReport: (payload) => axios.post(HTTP.FLY_REPORT, { payload })
}
